<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.dailyCover.id === null ? "ADICIONAR NOVA" : "ATUALIZAR" }} CAPA DO DIA</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <!-- Image -->
      <div class="p-6">
        <vs-input
          type="file"
          label="Faça o Upload da Imagem da Capa"
          @change="uploadThumbnail"
          class="w-full"
          accept="image/jpeg, image/png"
        />

        <vs-input
          v-model="dailyCoverData.picture_url"
          class="mt-1 w-full"
          name="Imagem da Capa"
          readonly
          hidden
          v-validate="'required'"
        />

        <span
          class="text-danger text-sm"
          v-show="errors.has('Imagem da Capa')"
        >{{ errors.first('Imagem da Capa') }}</span>

        <div v-if="!!dailyCoverData.picture_url">
          <div style="max-width: 200px; margin-top: 10px;">
            <img :src="dailyCoverData.picture_url" width="100%" height="100%" />
          </div>
          <a :href="dailyCoverData.picture_url" target="_blank">Visualizar Imagem da Capa</a>
        </div>

        <div style="clear: both;"></div>
      </div>

      <div class="p-6">
        <!-- PDF -->
        <vs-input
          type="file"
          label="Faça o Upload do PDF"
          @change="uploadPdf"
          class="mt-2 mb-5 w-full"
          accept="application/pdf"
        />

        <p v-if="chosenPdfName">
          Arquivo escolhido: <strong>{{chosenPdfName}}</strong>
        </p>

        <vs-input
          v-model="dailyCoverData.url"
          class="mt-1 w-full"
          name="PDF"
          hidden
          v-validate="'required'"
          readonly
        />

        <vs-button 
          v-if="!!dailyCoverData.url"
          target
          :href="{url: dailyCoverData.url}"
          type="flat"
          size="small"
          icon="picture_as_pdf"
        >
          Visualizar Arquivo
        </vs-button>

        <span
          class="text-danger text-sm"
          v-show="errors.has('PDF')"
        >
          {{ errors.first('PDF') }}
        </span>

        <div class="mt-10 mb-10 w-full flex flex-row">
            <div class="w-3/12 flex justify-start items-center mr-10">
              <div class="w-full flex justify-start items-center">
                <span class="phone-number-span mr-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                  <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="now">
                    Publicação Imediata
                  </vs-radio>

                  <vx-tooltip text="O Jornal Digital será publicada logo após a criação">
                    <feather-icon icon="HelpCircleIcon" class="ml-2"></feather-icon>
                  </vx-tooltip>
                </span>
              </div>
            </div>

            <div class="w-3/12 flex justify-start items-center">
              <div class="w-full flex justify-start items-center">
                <span class="phone-number-span ml-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                  <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="schedule">
                    Selecionar Horário
                  </vs-radio>

                  <vx-tooltip text="O Jornal Digital será publicada automaticamente na data e hora definida">
                    <feather-icon icon="HelpCircleIcon" class="ml-2"></feather-icon>
                  </vx-tooltip>
                </span>
              </div>
            </div>
          </div>

          <div v-if="sendingType === 'schedule'" class="mb-10 w-full">
            <div class="w-full">
              <span class="phone-number-span mr-12">
                Data e Hora da Publicação Automática
              </span>
            </div>

            <flat-pickr 
              :config="configdateTimePicker"
              v-model="schedulePublishAtPtBr"
              name="schedule_publish_at"
              class="w-full"
            />
          </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import fileHttp from '@/http/requests/file'

import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import 'flatpickr/dist/flatpickr.css'

import { uploadFile } from "@/utils";

export default {
  name: 'daily-cover-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dailyCover: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          url: '',
          picture_url: '',
          activated: true,
          schedule_publish_at: null,
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
      },
      dailyCoverData: {},
      chosenPdfName: '',
      configdateTimePicker: {
        enableTime: true,
        noCalendar: false,
        dateFormat: "d/m/Y H:i",
        locale: Portuguese,
        minDate: new Date
      },
      sendingType: '',
      schedulePublishAtPtBr: ''
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    initValues() {
      this.dailyCoverData = this.$_.cloneDeep(this.dailyCover);
      this.chosenPdfName = ''
      this.sendingType = ''
    },
    uploadThumbnail(e) {
      this.removePreviousImage();

      uploadFile(e)
        .then(uploadedImage => {
          this.dailyCoverData.picture_url = uploadedImage.fileUrl;
          this.$forceUpdate()
        })
        .catch(err => {
          console.error(err);
        });
    },
    removePreviousImage() {
      const fileUrl = this.dailyCoverData.picture_url;

      if (fileUrl) {
        const urlArray = fileUrl.split("/");
        const filename = urlArray[urlArray.length - 1];

        fileHttp.delete(filename).catch(err => {
          console.error(err);
        });
      }
    },
    submitData() {
      if (this.sendingType === '') {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao criar o Jornal Digital!',
          text: 'Você precisa selecionar entre "Publicação Imediata" ou "Selecionar Horário"'
        })
      }

      if (this.sendingType === 'schedule' && this.schedulePublishAtPtBr === '') {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao criar o Jornal Digital!',
          text: 'Você precisa definir uma data e um horário para a publicação automática'
        })
      }

      if (this.sendingType === 'schedule') {
        const ptDate = this.schedulePublishAtPtBr.split(' ')[0].split('/')
        const ptTime = this.schedulePublishAtPtBr.split(' ')[1] + ':00'
        this.dailyCoverData.schedule_publish_at = `${ptDate[2]}-${ptDate[1]}-${ptDate[0]} ${ptTime}`
      } else {
        this.dailyCoverData.schedule_publish_at = null
      }

      const that = this
      const dailyCoverData = this.$_.cloneDeep(this.dailyCoverData);

      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dailyCover.id !== null && this.dailyCover.id >= 0) {
            this.$store.dispatch("dailyCover/update", dailyCoverData).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.dailyCover.id
            this.$store.dispatch("dailyCover/add", dailyCoverData).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    },
    uploadPdf(e) {
      this.removePreviousPdf();

      const files = e.target.files

      if(files.length) {
        const file = files[0]

        fileHttp.upload(file).then(res => {
          const uploadedPdf = res.data;
          this.chosenPdfName = file.name
          this.dailyCoverData.url = uploadedPdf.fileUrl
        }).catch(err => {
          console.error(err)
        })
      }
    },
    removePreviousPdf() {
      const fileUrl = this.dailyCoverData.url;

      if (fileUrl) {
        const urlArray = fileUrl.split("/");
        const filename = urlArray[urlArray.length - 1]

        fileHttp
        .delete(filename)
        .catch(err => {
          console.error(err)
        })
      }
    },
  },
  components: {
    flatPickr,
    VuePerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
